var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6083 12.2616C41.5755 13.2771 41.5755 14.9262 40.6083 15.9416L20.801 36.7384C19.8338 37.7539 18.2632 37.7539 17.296 36.7384L7.39236 26.34C6.4252 25.3246 6.4252 23.6754 7.39236 22.66C8.35951 21.6445 9.93017 21.6445 10.8973 22.66L19.0524 31.2143L37.1111 12.2616C38.0782 11.2461 39.6489 11.2461 40.616 12.2616H40.6083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.9f0d7025ad6d9adbf783dc1af2b3a81e.svg";
export { ForwardRef as ReactComponent };